export default "__VITE_ASSET__2cuPrMkP__"